import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getCID(context, cid) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cid/access/obterCID", {CID: cid}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCIDBox(context, filtros) {
        filtros.componente = "SearchBoxCID";
        // filtros.locale = this.$i18n.locale;
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("cid/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async listarCondutasCID(context, idCID) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("cid/access/listarCondutasCID", { ID_CID: idCID }, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Condutas indisponíveis."); }
        return data;
    },
    async listarCIDsAtendimento(context, idAtendimento) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("cid/access/listarCIDsAtendimento", { ID_ATENDIMENTO: idAtendimento }, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Condutas indisponíveis."); }
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};